import {Button, Stack} from '@mui/material';
import {useEffect, useState} from 'react';
import {User} from '@cp/model';
import ConfettiPortal from '../../components/resultMotion/ConfettiPortal';
import SadFacesPortal from '../../components/resultMotion/SadFacesPortal';
import {env} from '../../config/env';

export interface SessionEffectProps {
  /** undefined means no animation will be shown, true for correct, false for incorrect */
  isCorrect?: boolean;
  user?: User | null;
}

export default function SessionEffect({isCorrect, user}: SessionEffectProps) {
  const [showConfetti, setShowConfetti] = useState(false);
  const [showSadFaces, setShowSadFaces] = useState(false);

  useEffect(() => {
    if (isCorrect !== undefined && user?.disableAnimation !== true) {
      if (isCorrect) {
        setShowConfetti(true);
      } else {
        setShowSadFaces(true);
      }
    }
  }, [isCorrect, user?.disableAnimation]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowConfetti(false);
    }, env.resultMotionDurationMs); // Keep using ms for setTimeout
    return () => clearTimeout(timeout);
  }, [showConfetti]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSadFaces(false);
    }, env.resultMotionDurationMs); // Match sad faces duration (3.5s) + delay (0.1s) in ms
    return () => clearTimeout(timeout);
  }, [showSadFaces]);

  return (
    <>
      {/* Dev Mode Buttons */}
      {env.isDev && (
        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            color="success"
            onClick={() => setShowConfetti(true)}
            size="small"
            sx={{fontSize: '0.75rem'}}
          >
            Test Correct
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => setShowSadFaces(true)}
            size="small"
            sx={{fontSize: '0.75rem'}}
          >
            Test Incorrect
          </Button>
        </Stack>
      )}

      {/* Result Motion Animations */}
      {showConfetti ? <ConfettiPortal durationSecs={env.resultMotionDurationMs / 1000} delaySecs={0.2} /> : null}
      {showSadFaces ? <SadFacesPortal durationSecs={3.5} delaySecs={0.1} /> : null}
    </>
  );
}
